module.exports = {
	"pathContext": {
		"path": "/shop/merino-infinity-scarf/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shop-merino-infinity-scarf.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/shop-merino-infinity-scarf.json
// module chunks = 188095844526377